import { boolean } from "../../shared/src/codecs/types/boolean";
import { integer } from "../../shared/src/codecs/types/integer";
import { nullCodec } from "../../shared/src/codecs/types/nullCodec";
import { overload } from "../../shared/src/codecs/types/overload";
import { required } from "../../shared/src/codecs/types/required";
import { union } from "../../shared/src/codecs/types/union";
import { PaymentMethod } from "./PaymentMethod";

export const HasProvidedProofOfFundsForOffer = overload(
    boolean(),
    required({
        funds_cash_verified_upto: union([integer(), nullCodec()]),
        funds_dip_verified_upto: union([integer(), nullCodec()]),
        amount: integer(),
        payment_method: PaymentMethod,
    }),
    // Mortgage/bridging loan buyers need both cash (deposit) and DIP (mortgage) amounts
    // Cash/other buyers only need cash amount
    // In all cases, total funds must cover the offer amount
    (details) => {
        const hasProvidedProof = (details.payment_method === "mortgage" || details.payment_method === "bridging_loan")
            ? details.funds_cash_verified_upto !== null && details.funds_dip_verified_upto !== null
            : details.funds_cash_verified_upto !== null || details.funds_dip_verified_upto !== null;

        return hasProvidedProof
            && (details.funds_cash_verified_upto || 0) + (details.funds_dip_verified_upto || 0) >= details.amount;
    },
);
